module.exports = __webpack_public_path__ + "static/media/logo-flower@3x.8170dcd0.png";